import assignToSuperadmin from '@custom/rtk-apis/microscopy/assignToSuperadmin';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const assignToSuperadminSlice = createSlice({
  name: 'assignToSuperadmin',
  initialState,
  reducers: {
    clearAssignState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(assignToSuperadmin.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(assignToSuperadmin.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.result;
        state.msg = action.payload;
      })
      .addCase(assignToSuperadmin.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.msg = action?.payload || 'Something went wrong!';
      });
  },
});

export default assignToSuperadminSlice.reducer;
export const { clearAssignState } = assignToSuperadminSlice.actions;
